var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccDrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 14.5,
    r: 14,
    stroke: "#0B335B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3996 12H9.59933C9.48998 12.0003 9.3828 12.0272 9.28932 12.0777C9.19583 12.1282 9.11959 12.2004 9.0688 12.2867C9.01801 12.3729 8.99458 12.4698 9.00105 12.567C9.00752 12.6642 9.04364 12.758 9.10552 12.8383L14.5057 19.784C14.7295 20.072 15.2683 20.072 15.4927 19.784L20.8929 12.8383C20.9554 12.7582 20.992 12.6643 20.9988 12.567C21.0057 12.4696 20.9824 12.3725 20.9315 12.2861C20.8807 12.1996 20.8042 12.1273 20.7105 12.0769C20.6167 12.0264 20.5092 11.9998 20.3996 12Z",
    fill: "#0B335B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccDrop);
export default __webpack_public_path__ + "static/media/acc-drop.4b74b8d4c7d935a8d2a689f980c0f3f1.svg";
export { ForwardRef as ReactComponent };